module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kj-Lb.3ab83296.png";